<template lang="pug">
  .target-operators
    .toolbar
      .mobile-title
        span.mobile-title__number.semibold 03
        span {{targetOperatorsTitle}}
      .toolbar__line
        h1.title {{targetOperatorsTitle}}
    .content.max-height-initial.page
      .edit-select
        select.select(@change="changeEditSelect")
          option(v-for="item in tabs" :key="Object.keys(item)[0]" :value="item") {{ Object.values(item)[0] }}
      .target-operators__top
        e-form-tabs.edit-tabs.target-operators__tabs(
          v-model="tabView"
          :tabs="tabs"
          @input="changeOperator"
        )
      .table
        .table__header.table__header_with-border
          .table__row
            .table__col.table__head.table__col_small.semibold Номер
            .table__col.table__head.semibold Наименование
            .table__col.table__head.table__col_small.semibold Единица измерения
            .table__col.table__head.table__col_small.semibold(v-for="year in years") {{ year }}
        .table__body
          .table__row(v-for="(item, index) in targets")
            .table__col.table__data.table__col_small № {{ index + 1 }}
            .table__col.table__data  {{ item.name }}
            .table__col.table__data.table__col_small  %
            .table__col.table__col_small(v-for="year in years")
              div(
                style="width: 100%"
                v-if="!tariffByYear[tko_operator_id + '-' + index][year].isEdit"
                @dblclick="setEdit(item, index, year)"
                :title="item.edited ? 'Чтобы отредактировать значение используйте двойной клик' : ''"
              )
                span(
                  v-if="tariffByYear[tko_operator_id + '-' + index]"
                ) {{tariffByYear[tko_operator_id + '-' + index][year].value || '0' }}
              div(
                v-else
                style="width: 100%"
                title="Нажмите Enter либо перестаньте редактировать значение чтобы его сохранить"
              )
                input.input.input_auto(
                  style="max-width:80px"
                  type="text"
                  @blur="saveEdit(item, index, year)"
                  @keyup.enter.prevent="saveEdit(item, index, year)"
                  v-model="tariffByYear[tko_operator_id + '-' + index][year].value"
                )
              span.error.table__col-error {{errors[`${index}-${year}`]}}

</template>
<script>
import { tko } from '@/api/api-endpoints'
import { REGION_CONFIG } from '../../config/regions'

const EDITED_ITEMS = {
  utilized:
    'Доля обезвреженных и утилизированных отходов в общем количестве образованных отходов I-V классов опасности',
  communal:
    'Доля обезвреженных твердых коммунальных отходов в общем количестве образованных твердых коммунальных отходов',
}
const UTILIZED_ID = 3
const COMMUNAL_ID = 4

export default {
  name: 'TargetOperators',
  data: () => ({
    tabs: [],
    targets: [],
    tabOperators: {},
    tariffByYear: {},
    tabView: 'tab1',
    tko_operator_id: null,
    years: [],
    errors: {},
    lastYear: 0,
  }),
  computed: {
    targetOperatorsTitle() {
      return REGION_CONFIG.texts.targetOperatorsTitle
    },
  },
  methods: {
    changeOperator(val) {
      this.tko_operator_id = this.tabOperators[val]?.id

      if (this.tko_operator_id) {
        this.getTargets(this.tko_operator_id)
      }
    },
    getYears() {
      this.targets.forEach((item, index) => {
        this.$set(this.tariffByYear, this.tko_operator_id + '-' + index, {
          isEdit: false,
          value: 0,
        })
        item.values.forEach((el) => {
          this.years.push(el.year)
          this.$set(
            this.tariffByYear[this.tko_operator_id + '-' + index],
            el.year,
            {
              isEdit: false,
              value: el.value,
            }
          )
        })
        Object.values(this.tariffByYear).forEach((el) => {
          this.years.forEach((year) => {
            if (!el[year]) {
              this.$set(
                this.tariffByYear[this.tko_operator_id + '-' + index],
                year,
                {
                  isEdit: false,
                  value: '0',
                }
              )
            }
          })
        })
      })
      this.years = Array.from(new Set(this.years))
      this.lastYear = this.years.at(-1)
    },
    changeEditSelect(event) {
      const val = this.tabs[event.target.selectedIndex]
      this.tabView = Object.keys(val)[0]
    },
    async getTargets(tko_operator_id) {
      this.targets = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: tko.percentBurial(tko_operator_id, this.$route),
        })
      ).data.data
      this.targets = this.targets.map((item) => {
        item.edited = Object.values(EDITED_ITEMS).includes(item.name)
        return item
      })
      this.getYears()
    },
    async getOperators() {
      const operators = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: tko.regionalOperators(),
        })
      ).data.data
      this.tabs = operators.map((item, index) => {
        const tabName = `tab${index + 1}`
        this.tabOperators[tabName] = { id: item.id }
        return {
          [tabName]: `Зона ${index + 1}`,
        }
      })
      this.tko_operator_id = operators[0].id
      this.getTargets(operators[0].id)
    },
    setEdit(item, index, year) {
      if (!item.edited) {
        return false
      }
      this.errors = {}
      this.tariffByYear[this.tko_operator_id + '-' + index][year].isEdit = true
    },
    addNewCol() {
      let addedYear = this.lastYear + 1
      if (addedYear < 1990) {
        addedYear = 1990
      }
      this.years.push(addedYear)
      this.getYears()
    },
    async saveEdit(item, index, year) {
      this.tariffByYear[this.tko_operator_id + '-' + index][year].isEdit = false
      let data = {}
      if (index === UTILIZED_ID) {
        data.burial_recycle_perc =
          this.tariffByYear[this.tko_operator_id + '-' + index][year].value
      }
      if (index === COMMUNAL_ID) {
        data.burial_solid_perc =
          this.tariffByYear[this.tko_operator_id + '-' + index][year].value
      }
      const result = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          url: tko.operatorGarbageOperationPost({
            query: {
              sourceId: this.tko_operator_id,
              year,
              type: 'detail',
            },
          }),
        })
      ).data.data
      const id = result[0].id
      try {
        await this.$store.dispatch('updateModel', {
          url: tko.operatorGarbageOperationPatch({
            query: {
              sourceId: id,
              type: 'detail',
            },
          }),
          data,
        })
      } catch (e) {
        this.$set(
          this.errors,
          `${index}-${year}`,
          Object.values(e.data.errors).join()
        )
      }

      this.getTargets(this.tko_operator_id)
    },
  },
  created() {
    this.getOperators()
  },
}
</script>
